/* Polsk katalog for locale-autopilot-customers.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'ap.customerFollowup.title': 'Obsługa klientów',
  'ap.customerFollowup.waiting': 'Oczekuje na odpowiedź',
  'ap.customerFollowup.ready': 'Gotowe do oferty',
  'ap.customerFollowup.document': 'Oferta lub zamówienie do dalszych działań',
  'ap.customerFollowup.openChat': 'Otwórz czat',
  'ap.customerFollowup.empty': 'Obecnie żaden klient nie wymaga kontaktu.',
});
